import HeaderLegacyLinksPopoverComponent from './header-legacy-links-popover.component'

const HeaderLegacyLinksPopoverModule = angular.module('cdbl.header-legacy-links-popover', [

])
  .component('cdblHeaderLegacyLinksPopover', HeaderLegacyLinksPopoverComponent)
  .name

export default HeaderLegacyLinksPopoverModule
